import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api/connect`;

const auth = token => ({ headers: token ? { Authorization: `Bearer ${token}` } : {} });

/** Admin → Integrations → Remote access (RestoYaar Connect, bible §64). Admin only. */
export const getConnect = async token => (await axios.get(API, auth(token))).data;
export const setConnect = async (enabled, token) => (await axios.put(API, { enabled }, auth(token))).data;
